<template>
  <div class="c-creat-logo">
    <div class="c-thumb">
      <div class="c-thumb-wrapper m-default-bg">
        <Spin v-show="loading" fix>
          <Icon type="ios-loading" size="30" class="c-fix-loading"></Icon>
          <div>上传中...</div>
        </Spin>
        <div class="c-alt-upload" :class="{ 'c-hide-upload': value }">
          <div class="c-alt-container">
            <Button v-if="value" type="primary" @click="$emit('on-select')">更新LOGO</Button>
            <Button v-else type="primary" @click="$emit('on-select')">选择LOGO</Button>
            <Upload v-if="local" action="" :before-upload="beforeUpload">
              <Button type="default">本地上传</Button>
            </Upload>
          </div>
          <div class="c-alt-txt m-muted">
            <span>宽高比1:1，大小1M以下</span>
            <span>尺寸需为108*108</span>
            <span>支持JPG、PNG等图片格式</span>
          </div>
        </div>
        <span v-if="info.msg" class="c-thumb-error">不符合：{{ info.msg }}</span>
        <img v-if="value" :src="image" alt="" />
      </div>
    </div>
  </div>
</template>
<script>
import { isArray } from '@/common/js/utils'
export default {
  name: 'CardIcon',
  props: {
    value: {
      type: String
    },
    local: {
      type: Boolean,
      default: false
    },
    sources: {
      type: Array,
      default() {
        return []
      }
    },
    url: {
      type: String,
      default: ''
    }
  },
  computed: {
    info() {
      if (this.value && isArray(this.sources)) {
        const item = this.sources.filter((ret) => String(ret.id) === this.value).pop()
        return item || {}
      } else return {}
    },
    image() {
      const { url } = this.info
      return url || this.url
    }
  },
  data() {
    return {
      loading: null
    }
  },
  methods: {
    beforeUpload() {}
  }
}
</script>
<style lang="scss" scoped>
.m-default-bg {
  background-color: #e8e8e8;
}

.m-muted {
  color: #666;
  font-size: 85%;
}

.c-fix-loading {
  margin-bottom: 12px;
  animation: ani-demo-spin 1s linear infinite;
}

.c-creat-logo {
  width: 200px;
  min-height: 200px;
  position: relative;
  float: left;

  &:hover {
    .c-thumb {
      border-color: #57a3f3;
    }

    .m-remove {
      opacity: 1;
    }
  }

  .c-thumb {
    background-color: #fff;
    border: solid 1px #ddd;
    transition: border 0.2s ease-in-out;

    .c-thumb-wrapper {
      width: 100%;
      height: 198px;
      position: relative;
      z-index: 9;

      .c-thumb-error {
        display: inline-block;
        position: absolute;
        z-index: 1;
        margin-top: 3px;
        padding: 2px 4px 0;
        line-height: 1.3;
        color: #ff4400;
        background: #000;
        background: -webkit-linear-gradient(left, rgba(0, 0, 0, 1), rgba(0, 0, 0, 0));
        background: -ms-linear-gradient(left, rgba(0, 0, 0, 1), rgba(0, 0, 0, 0));
        background: -moz-linear-gradient(left, rgba(255, 255, 255, 1) 100%, rgba(255, 255, 255, 0) 0%);
        background: -o-linear-gradient(left, rgba(255, 255, 255, 1) 100%, rgba(255, 255, 255, 0) 0%);
      }

      img {
        width: 100%;
        height: 100%;
        display: block;

        &.vertical-img {
          width: 120px;
          margin: 0 auto;
        }
      }

      .c-alt-upload {
        width: 100%;
        height: 100%;
        padding: 0 12px;
        position: absolute;
        z-index: 7;
        top: 0;
        left: 0;
        text-align: center;

        .c-alt-container {
          padding: 42px 0px 32px;
          display: flex;
          justify-content: center;
        }

        .c-alt-txt {
          padding: 6px 12px;

          span {
            display: block;
            line-height: 1.4;
          }
        }
      }

      .c-hide-upload {
        opacity: 0;

        &:hover {
          opacity: 1;
          background-color: rgba(0, 0, 0, 0.6);

          .c-alt-txt {
            color: #fff;
          }
        }
      }
    }
  }
}
</style>
